<template>
  <helper-layout :loaded="mx_loaded">
    <v-card class="details-wrap">
      <v-layout row style="min-width: 725px;">
        <div>
          <div class="imgWrap">
            <img
              :src="
                productDetail.detailData.pictures &&
                  productDetail.detailData.pictures[0]
                  ? ImageUrl(
                    productDetail.detailData.pictures[0].pictureKey,
                    328,
                    328
                  )
                  : require('../../assets/img_default330.png')
              "
            >
          </div>
          <div class="imgsmallWrap" style="display:flex;">
            <img
              v-if="
                productDetail.detailData.pictures &&
                  productDetail.detailData.pictures.length > 1
              "
              :src="oLeft"
              alt="left-arrow"
              class="arrowFontLeft"
              @click="leftimage(-1)"
            >
            <div>
              <div
                v-if="
                  productDetail.detailData.pictures &&
                    productDetail.detailData.pictures.length > 0
                "
                class="smallImg"
              >
                <div
                  v-for="(item, index) in productDetail.detailData.pictures"
                  :key="index"
                  class="smallImage"
                >
                  <img
                    :src="ImageUrl(item.pictureKey, 80, 80)"
                    :alt="item.sort"
                  >
                </div>
              </div>
            </div>
            <img
              v-if="
                productDetail.detailData.pictures &&
                  productDetail.detailData.pictures.length > 1
              "
              :src="oRight"
              alt="right-arrow"
              class="arrowFontRight"
              @click="rightimage(1)"
            >
          </div>
        </div>
        <div class="product-details">
          <div class="productName">
            {{ productDetail.detailData.name }}
          </div>
          <v-layout justify-betwben>
            <v-flex>
              <!-- 英文名 -->
              <div class="detailWrap">
                <label class="item-title" for="status"> {{ $t("Views.Goods.productEnglishNameLabel") }}</label>
                <label for="">：</label>
                <span class="nameProductTips">
                  <material-tooltips
                    diable-color="#515151"
                    :content="productDetail.detailData.englishName"
                    :o-width="300"
                    :tip-show="true"
                  />
                </span>
              </div>
              <!-- 状态 -->
              <div class="detailWrap">
                <label class="item-title" for="status">
                  {{ $t("Views.Goods.status") }}</label><label for="">：</label>
                <span
                  :style="
                    `color:${
                      productDetail.detailData.status === 'StopSale'
                        ? 'red'
                        : '#00A854'
                    } `
                  "
                  class=" oValue"
                >{{
                  productDetail.detailData.status === "StopSale"
                    ? $t("Views.Goods.stopSale")
                    : $t("Views.Goods.onSale")
                }}</span>
              </div>
              <!-- 弥生贩卖 -->
              <div class="detailWrap">
                <label class="item-title" for="serialNumber">{{
                  $t("Views.Goods.deNumberLabel")
                }}</label><label for="">：</label>
                <span class=" oValue">
                  {{ productDetail.detailData.yayoiSerialNumber }}
                </span>
              </div>
              <!-- 排序值 -->
              <div class="detailWrap">
                <label class="item-title" for="sort">
                  {{ $t("Views.Goods.sort") }}</label><label for="">：</label>
                <span class=" oValue">
                  {{ productDetail.detailData.sort }}
                </span>
              </div>
              <!-- 装箱数 -->
              <div class="detailWrap">
                <label class="item-title" for="packingNumber">{{ $t("Views.Goods.packingQuantity") }}</label><label for="">：</label>
                <span class=" oValue">
                  {{ productDetail.detailData.packingNumber || '' }}
                </span>
              </div>
              <!-- 起订量 -->
              <div class="detailWrap">
                <label class="item-title" for="">{{
                  $t("Views.Goods.miniOrderQuantity")
                }}</label> <label for="">：</label>
                <span class=" oValue">
                  {{ productDetail.detailData.miniOrderQuantity }}
                </span>
              </div>
              <!-- 零售价 -->
              <div class="detailWrap">
                <label class="item-title" for="costPrice">
                  {{ $t("Views.Goods.retailPriceLabel") }}</label><label for="">：</label>
                <span class=" oValue">
                  {{
                    productDetail.detailData.retailPrice | moneyFmt
                  }}
                </span>
              </div>
            </v-flex>
            <v-flex class="margin-left-76">
              <!-- 中文 -->
              <div class="detailWrap">
                <label class="item-title" for="capacity">{{
                  $t("Views.Goods.productChineseNameLabel")
                }}</label><label for="">：</label>
                <span class="nameProductTips">
                  <material-tooltips
                    diable-color="#515151"
                    :content="productDetail.detailData.chineseName"
                    :o-width="300"
                    :tip-show="true"
                  />
                </span>
              </div>
              <!-- 商品分类 -->
              <div class="detailWrap">
                <label class="item-title" for="category">{{
                  $t("Views.Goods.categoryName")
                }}</label><label for="">：</label>
                <span class=" oValue">
                  {{
                    productDetail.detailData.category
                      ? productDetail.detailData.category.name
                      : null
                  }}
                </span>
              </div>
              <!-- 条形码 -->
              <div class="detailWrap">
                <label for="serialNumber" class="item-title">{{
                  $t("Views.Goods.serialNumberLabel")
                }}</label><label for="">：</label>
                <span class=" oValue">
                  {{ productDetail.detailData.serialNumber }}
                </span>
              </div>
              <!-- 容量 -->
              <div class="detailWrap">
                <label class="item-title" for="capacity">{{
                  $t("Views.Goods.capacity")
                }}</label><label for="">：</label>
                <span class=" oValue">
                  {{ productDetail.detailData.capacity }}
                </span>
              </div>
              <!-- 成本价 -->
              <div class="detailWrap">
                <label class="item-title" for="costPrice">
                  {{ $t("Views.Goods.costPriceLabel") }}</label><label for="">：</label>
                <span class=" oValue">
                  {{
                    productDetail.detailData.costPrice | moneyFmt
                  }}
                </span>
              </div>
              <!-- 订货价 -->
              <div class="detailWrap">
                <label class="item-title" for="orderPrice">{{
                  $t("Views.Goods.orderPrice")
                }}</label><label for="">：</label>
                <span class="oRed oValue">
                  {{
                    productDetail.detailData.orderPrice | moneyFmt
                  }}</span>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-layout>
    </v-card>
    <div class="margin-top-20">
      <v-tabs :value="activeTab" active-class="tabActive" @change="tabActived">
        <v-tabs-slider :color="color" />
        <v-tab>
          {{ $t("Views.Goods.productIntroduction") }}
        </v-tab>
        <v-tab>
          {{ $t("Views.Goods.productLinks") }}
        </v-tab>
        <v-tab>
          {{ $t("Views.Goods.operateLogs") }}
        </v-tab>
        <v-tab-item>
          <v-card class="details-wrap margin-top-20">
            <div
              v-if="productDetail.detailData.description"
              class="description"
            >
              {{ productDetail.detailData.description }}
            </div>
            <div v-else class="text-align-center">
              {{ $t("Views.Goods.noIntroduction") }}
            </div>
          </v-card>
        </v-tab-item>
        <v-tab-item class="margin-top-20">
          <material-table
            :headers="productLinkHedaer"
            :items="productDetail.detailData.productLinks"
            :has-paginate="false"
            item-key="id"
          />
        </v-tab-item>
        <v-tab-item class="margin-top-20">
          <ams-operate-logs
            :logs="
              productDetail.productRecord && productDetail.productRecord.items
            "
          />
        </v-tab-item>
      </v-tabs>
    </div>
    <div style="textAlign:center;marginTop:20px;">
      <v-btn
        v-if="canEdit && productDetail.detailData.status === 'StopSale'"
        :color="color"
        @click="modify(productDetail.detailData, 'edit')"
      >
        {{ $t("Views.Goods.edit") }}
      </v-btn>
      <v-btn color="cancel" outline @click="goBack">
        {{ $t("Views.Goods.getBack") }}
      </v-btn>
    </div>
  </helper-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'
import { format, parse } from 'date-fns'
import oLeft from '@/assets/oleft.png'
import oRight from '@/assets/oright.png'
export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      oLeft: oLeft,
      oRight: oRight,
      recordList: [],
      productId: '',
      account: 0,
      tab: null,
      activeTab: 'tab-0',
      productLinkHedaer: [{ text: $t('Views.Order.index'), align: 'center', sortable: false, width: 50, isSort: true },
        {
          text: $t('Views.Order.product_name_label'),
          sortable: false,
          render: (h, param) => {
            return h('material-img', {
              props: {
                desc: param.row.linkedProduct.name,
                pictureKey: param.row.linkedProduct.pictureKey,
                pictureWidth: 50,
                pictureHeight: 50,
                preview: true,
                serialNumber: param.row.linkedProduct.serialNumber,
                descW: 300
              }
            })
          }
        },
        { text: $t('Views.Goods.capacity'), value: 'linkedProduct.capacity', type: 'nest', sortable: false },
        { text: $t('Views.Goods.orderPrice'), sortable: false, isCurrency: { type: 'nest' }, value: 'linkedProduct.orderPrice', prefix: '¥' }
      ]
    }
  },
  computed: {
    ...mapState('goods', ['productDetail', 'productDetail/detailData', 'productDetail/productRecord']),
    color() {
      return this.$store.state.app.color
    },
    canEdit() {
      return this.$util.tool.hasPerm('ProductManager.ProductsList.CreateOrEdit')
    }
  },
  created() {
    this.productId = this.$route.query.id
    if (this.productId) {
      this.getProDetailData(this.productId).then(() => {
        this.mx_loaded_fn() // 页面加载完成
      })
      this.getProductRecordData(this.productId).then(() => {
        this.mx_loaded_fn() // 页面加载完成
      })
    }
  },
  methods: {
    ...mapActions('goods', ['getProductRecordData', 'getProDetailData']),
    goBack() {
      this.$router.go(-1)
    },
    formatDate(date, fmt) {
      return format(parse(date), fmt)
    },
    leftimage(index) {
      const first = this.productDetail.detailData.pictures.splice(index, 1)[0]
      this.productDetail.detailData.pictures.unshift(first)
    },
    rightimage() {
      this.account++
      if (this.account < this.productDetail.detailData.pictures.length) {
        const next = this.productDetail.detailData.pictures.splice(this.account, 1)[0]
        this.productDetail.detailData.pictures.unshift(next)
      } else {
        const first = this.productDetail.detailData.pictures.splice(-1, 1)[0]
        this.productDetail.detailData.pictures.unshift(first)
      }
    },
    ImageUrl(data, width, height) {
      return `${process.env.VUE_APP_FILE_URL}/${data}?imageView2/1/w/${width}/h/${height}`
    },
    tabActived(value) {
      this.activeTab = value
    },
    modify(record, type) {
      this.$router.push({
        name: 'goodsUpdate',
        query: {
          id: record.id,
          type: type
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>

.nameProductTips {
  font-size: 14px;
  color: #000000;
  letter-spacing: 0;
  .tooltip-class {
    display: flow-root;
  }
}
</style>
<style lang="scss" scoped>
.description {
  font-size: 14px;
  color:#000000;
}
.smallImg {
  display: flex;
  width: 225px;
  height: 86px;
  overflow-x: auto;
  .smallImage {
    justify-content: center;
    align-items: center;
    height: 80px;
    min-width: 80px;
    display: flex;
    img {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
}

.margin-left-76 {
  margin-left:76px;
}

.product-details {
  margin-left: 20px;
}

.smallImg::-webkit-scrollbar {
  width: 0px;
  height: 8px;
}

/* 滚动槽 */
.smallImg::-webkit-scrollbar-track {
  box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

/* 滚动条滑块 */
.smallImg::-webkit-scrollbar-thumb {
  border-radius: 10px;
  // background: rgba(0, 0, 0, 0.2);
  background: lightgray;
  box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}

.smallImg::-webkit-scrollbar-thumb:window-inactive {
  // background: rgba(198, 174, 221, 0.4);
  background: rgba(198, 174, 221, 0.4);
}

.padding-20 {
  padding: 20px;
}

.detailWrap {
  margin-top: 30px;
}

.nameProductTips {
  display: inline-flex;
}

.item-title {
  min-width: 128px;
}

.imgWrap {
  width: 330px;
  border: 1px solid #e0e0e0;
  height: 328px;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
  img{
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
}

.imgsmallWrap {
  padding:0 10px ;
  width: 330px;
  min-width: 257px;
  border: 1px solid #e0e0e0;
  border-top: none;
  align-items: center;
}

.oimage {
  border: 1px solid #e0e0e0;
  text-align: center;
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
}
table {
  border-collapse: collapse;
  border: 1px solid #e0e0e0;
  width: 100%;
  margin-top: 20px;
}

.stock div {
  padding: 8px 18px;
  margin-bottom: 10px;
}

.oRed {
  color: red;
  font-weight: bold;
}

.arrowFontLeft {
  cursor: pointer;
  font-weight: bold;
  width:32px;
  height: 32px;
  position: relative;
  margin-right: 10px;
}
.arrowFontRight {
  cursor: pointer;
  font-weight: bold;
  width:32px;
  height: 32px;
  position: relative;
  margin-left: 10px;

}

.centerBtn {
  text-align: center;
  margin-top: 40px;
}

.productName {

  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  font-weight: bold;
}
</style>
